<template>
  <v-autocomplete
    v-model="church"
    :items="churches"
    label="Church"
    @input="onInput"
  />
</template>

<script>
export default {
  name: 'ChurchSelect',
  data: () => ({
    church: null,
    churches: []
  }),
  props: {
    value: Number
  },
  mounted: function () {
    // Make sure we get our initial value right since our watch method won't
    // trigger unless the value *changes*, which might not always be the case
    this.church = this.value

    var _this = this
    this.axios.get('/churches/')
      .then(function (res) {
        for (var i in res.data) {
          var v = res.data[i]
          var title = v.name + ' (' + v.city + ', ' + v.state + ')'
          _this.churches.push({ text: title, value: v.id })
        }
      })
      .catch(this.$root.apiErrorHandler())
  },
  watch: {
    value: function () {
      this.church = this.value
    }
  },
  methods: {
    // Propagate our selection so it works with a parent v-model
    onInput: function () {
      this.$emit('input', this.church)
    }
  }
}
</script>
